// Copyright (c) 2019 Deere & Company

import './error-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import PropTypes from 'prop-types';
import React from 'react';

export const ErrorAlertBar = ({
    alertTitle, canDismiss, dismissHandler,
    timeoutLength, willAutoDismiss, children,
}) => (
    <div className="error-alert-bar">
        <AlertBarBase
            alertTitle={alertTitle}
            canDismiss={canDismiss}
            dismissHandler={dismissHandler}
            iconClass="icon-alert-warning-white"
            timeoutLength={timeoutLength}
            willAutoDismiss={willAutoDismiss}
        >
            {children}
        </AlertBarBase>
    </div>
);

ErrorAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    canDismiss: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool,
    dismissHandler: PropTypes.func,
    children: PropTypes.any,
};

ErrorAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: false,
};
